import { getProductFilteringAsQueryString } from '../Actions/ProductFiltering.action';
import {
  PRODUCT_FILTERING_RECEIVE,
  PRODUCT_LISTING_SET_PRODUCTS,
  PRODUCT_FILTERING_RECEIVE_BRAND_CATEGORY_FILTERS,
} from '../constants';

export const historyMiddleware = ({ dispatch, getState }) => (next) => (
  action
) => {
  if (typeof action === 'function') {
    // then call the function and pass `dispatch` and `getState` as arguments
    return action(dispatch, getState);
  }
  const { type, payload } = action;
  const productFilteringState = getState().productFiltering;
  const productListingState = getState().productListing;

  switch (type) {
    case PRODUCT_FILTERING_RECEIVE: {
      // The backend filtering response does not include the client-side brand
      // category tree, so keep it when producing the canonical query string.
      const nextProductFilteringState = {
        ...productFilteringState,
        ...payload,
        brandCategoryFilters: productFilteringState.brandCategoryFilters,
      };
      const queryString = getProductFilteringAsQueryString(
        nextProductFilteringState,
        payload.productListing ?? productListingState
      );

      replaceFilteringQuery(queryString, 'filter');
      break;
    }
    case PRODUCT_FILTERING_RECEIVE_BRAND_CATEGORY_FILTERS: {
      // Middleware runs before the reducer, so serialize the incoming category
      // tree rather than the previous tree from the store.
      const nextProductFilteringState = {
        ...productFilteringState,
        brandCategoryFilters: payload,
      };
      const filteringQuery = new URLSearchParams(
        getProductFilteringAsQueryString(
          nextProductFilteringState,
          productListingState
        )
      );
      const query = new URLSearchParams(window.location.search);
      const selectedCategory = filteringQuery.get('category');

      query.delete('category');
      if (selectedCategory) {
        query.set('category', selectedCategory);
      }

      replaceQuery(query, 'brandCategoryFilter');
      break;
    }
    case PRODUCT_LISTING_SET_PRODUCTS:
      setProductsCount(payload?.products);
      break;
  }
  return next(action);
};

const setProductsCount = (products) => {
  const query = new URLSearchParams(window.location.search);
  if (products?.length > 0) {
    query.set('count', products.length);
  } else {
    query.delete('count');
  }
  replaceQuery(query, 'setProductsCount');
};

const replaceFilteringQuery = (queryString, stateName) => {
  const query = new URLSearchParams(queryString);
  const currentQuery = new URLSearchParams(window.location.search);

  if (currentQuery.has('count')) {
    query.set('count', currentQuery.get('count'));
  }

  replaceQuery(query, stateName);
};

const replaceQuery = (query, stateName) => {
  const url = new URL(window.location.href);
  url.search = query.toString();
  window.history.replaceState(stateName, null, url.toString());
};
